import {AnimatePresence, motion} from 'framer-motion/dist/framer-motion'
import '../../styles/ModalBase.css'

export const ModalBase = (props: any) => {
  return (
    <AnimatePresence>
      <div className='modal-base-bg modal-base overlay-base'>
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
          <div className={`modal-base-div-2 modal-base-content-2`} style={{...props.Styles}}>
            {props.children}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  )
}
